export default {
  more: '더 보기',
  retract: '간략히 보기',
}
